import React, { Component } from 'react'

import { Container } from '../../styles/defaults'
import { Content } from './styles'

class Sentence extends Component {
  render() {
    const { text } = this.props

    return (
      <Container>
        <Content>{text}</Content>
      </Container>
    )
  }
}

export default Sentence



// WEBPACK FOOTER //
// ./src/components/Sentence/index.js